import React, { useEffect, useState } from "react";
import { Play, Pause } from "lucide-react";
import { togglePreview, subscribe, playingUrl } from "@/lib/audio";

export const PreviewButton = ({ url, testId, label = false }) => {
  const [playing, setPlaying] = useState(playingUrl() === url);
  useEffect(() => subscribe((u) => setPlaying(u === url)), [url]);
  if (!url) return null;
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={(e) => {
        e.stopPropagation();
        togglePreview(url);
      }}
      className="inline-flex items-center gap-1.5 rounded-full border border-[color:var(--brand-border)] bg-white px-3 py-1.5 text-xs font-medium text-[color:var(--brand-graphite)] transition-colors hover:bg-[color:var(--brand-marsala-soft)]"
    >
      {playing ? <Pause className="h-3.5 w-3.5" /> : <Play className="h-3.5 w-3.5" />}
      {label && (playing ? "Pausar" : "Ouvir")}
    </button>
  );
};
